"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LottoDtoToJSON = exports.LottoDtoFromJSONTyped = exports.LottoDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function LottoDtoFromJSON(json) {
    return LottoDtoFromJSONTyped(json, false);
}
exports.LottoDtoFromJSON = LottoDtoFromJSON;
function LottoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'nomeLotto': !runtime_1.exists(json, 'nomeLotto') ? undefined : json['nomeLotto'],
        'idStatoLotto': !runtime_1.exists(json, 'idStatoLotto') ? undefined : json['idStatoLotto'],
        'statoNome': !runtime_1.exists(json, 'statoNome') ? undefined : json['statoNome'],
        'matricolaOperatore': !runtime_1.exists(json, 'matricolaOperatore') ? undefined : json['matricolaOperatore'],
        'nominativoOperatore': !runtime_1.exists(json, 'nominativoOperatore') ? undefined : json['nominativoOperatore'],
        'filialeOperatore': !runtime_1.exists(json, 'filialeOperatore') ? undefined : json['filialeOperatore'],
        'tipoProfiloOperatore': !runtime_1.exists(json, 'tipoProfiloOperatore') ? undefined : json['tipoProfiloOperatore'],
        'dataInizioCampagna': !runtime_1.exists(json, 'dataInizioCampagna') ? undefined : (new Date(json['dataInizioCampagna'])),
        'dataFineCampagna': !runtime_1.exists(json, 'dataFineCampagna') ? undefined : (new Date(json['dataFineCampagna'])),
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'datiCertificati': !runtime_1.exists(json, 'datiCertificati') ? undefined : _1.DatiCertificatiDtoFromJSON(json['datiCertificati']),
    };
}
exports.LottoDtoFromJSONTyped = LottoDtoFromJSONTyped;
function LottoDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'nomeLotto': value.nomeLotto,
        'idStatoLotto': value.idStatoLotto,
        'statoNome': value.statoNome,
        'matricolaOperatore': value.matricolaOperatore,
        'nominativoOperatore': value.nominativoOperatore,
        'filialeOperatore': value.filialeOperatore,
        'tipoProfiloOperatore': value.tipoProfiloOperatore,
        'dataInizioCampagna': value.dataInizioCampagna === undefined ? undefined : (value.dataInizioCampagna.toISOString()),
        'dataFineCampagna': value.dataFineCampagna === undefined ? undefined : (value.dataFineCampagna.toISOString()),
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'datiCertificati': _1.DatiCertificatiDtoToJSON(value.datiCertificati),
    };
}
exports.LottoDtoToJSON = LottoDtoToJSON;
